
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/discover-more/showcase",
      function () {
        return require("private-next-pages/material-ui/discover-more/showcase.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/discover-more/showcase"])
      });
    }
  